import { useGetTestingProgramsTestingProgramIdSuspense } from "api/generated/testing-programs/testing-programs";

export function useTestingProgramDetailsQuery(testingProgramId: number) {
    return useGetTestingProgramsTestingProgramIdSuspense(testingProgramId, {
        query: { select: (response) => response.data },
    });
}
